/**
 * The question key rule on its own, with no imports: keys.ts is its public home (it re-exports KEY_RE), and the
 * intake field schema (../intake.ts) validates a library form item's `question_key` with it without importing the
 * profile modules that themselves import intake.ts.
 */
/** `<section>.<snake>` (shared shelf) or `custom.<slug>_<hash6>` (agency shelf). Mirrors the SQL CHECK. */
export const KEY_RE = /^[a-z][a-z0-9_]*\.[a-z0-9_]{1,80}$/;
//# sourceMappingURL=key-rule.js.map